import React from "react";

import Main from "./Index/Main";

import Context from "./Context";
import PolicyPlanTemplateContext from "../../../contexts/PolicyPlanTemplateContext";

export default function Index({ enterpriseId }) {
  return (
    <Context enterpriseId={enterpriseId}>
      <PolicyPlanTemplateContext>
        <Main />
      </PolicyPlanTemplateContext>
    </Context>
  );
}
